import { useState } from 'react';
import { expandConstants } from 'utils';

import { useConstantsQuery } from 'modules/apiData/dataApiSlice';

import { useOrganization } from '../../modules/organization/useOrganization';
import { DSP_ADFORM, DSP_AMAZON, DSP_CRITEO, DSP_VISTAR } from '../../utils/constants';
import { CreateAllTouchReport } from './CreateAllTouchReport';
import { CreatePerformanceReport } from './CreatePerformanceReport';
import { CreateReportWrapperProps } from './ReportsTypes';

export const CreateReportWrapper = ({
  setIsCreateFormOpen,
  selectedReport,
  refetch,
}: CreateReportWrapperProps) => {
  const { data: constants } = useConstantsQuery(null);
  const { dsp } = useOrganization();

  const reportTypes = expandConstants((constants && constants.ReportType) || {});

  let defaultReportType;

  switch (dsp) {
    case DSP_ADFORM:
      defaultReportType = reportTypes.ADFORM_PERFORMANCE.value;
      break;
    case DSP_VISTAR:
      defaultReportType = reportTypes.VISTAR.value;
      break;
    case DSP_CRITEO:
      defaultReportType = reportTypes.CRITEO.value;
      break;
    case DSP_AMAZON:
      defaultReportType = reportTypes.AMAZON.value;
      break;
    default:
      defaultReportType = reportTypes.PERFORMANCE.value;
      break;
  }
  const [reportType, setReportType] = useState(selectedReport?.reportType || defaultReportType);

  return reportType === reportTypes.PERFORMANCE.value ||
    reportType === reportTypes.ADFORM_PERFORMANCE.value ||
    reportType === reportTypes.VISTAR.value ||
    reportType === reportTypes.CRITEO.value ||
    reportType === reportTypes.AMAZON?.value ? (
    <CreatePerformanceReport
      setIsCreateFormOpen={setIsCreateFormOpen}
      selectedReport={selectedReport}
      refetch={refetch}
      setReportType={setReportType}
      reportType={reportType}
    />
  ) : (
    <CreateAllTouchReport
      setIsCreateFormOpen={setIsCreateFormOpen}
      selectedReport={selectedReport}
      refetch={refetch}
      setReportType={setReportType}
      reportType={reportType}
    />
  );
};
